// Generated by GitHub Copilot
// Thin React wrapper around the official chart.js package (installed via npm).
// 'chart.js/auto' registers all controllers/elements/scales, matching the
// full-featured UMD build the HTML template used — but bundled, so it works
// offline and in dev without any CDN.
import React, { useEffect, useRef } from 'react';
import ChartJS from 'chart.js/auto';

// Palette constants used when building chart configs (match the template).
export const PALETTE = {
  P900: '#0A1A3A', P800: '#142B5C', P700: '#1D3F80', P600: '#2151A1',
  P500: '#2D68C4', P400: '#4D84D6', P300: '#7AAAE3',
  RED: '#E32934', GREEN: '#1A7A3C', AMBER: '#B85C00', GREY: '#9CA3AF', PURPLE: '#6B3FAC',
};

// Global defaults, applied once on import (match the template).
ChartJS.defaults.font.family = "'Inter', sans-serif";
ChartJS.defaults.font.size = 11;
ChartJS.defaults.color = PALETTE.GREY;

/** Renders a Chart.js chart. `config` should be memoised by the caller. */
export function Chart({ config }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return undefined;
    chartRef.current = new ChartJS(canvasRef.current, config);
    return () => {
      chartRef.current?.destroy();
      chartRef.current = null;
    };
  }, [config]);

  return <canvas ref={canvasRef} />;
}
